import CGVConsult from '@/views/CGVConsult.vue';
import CGVPreConsultForm from '@/views/CGVPreConsultForm.vue';
import CGVData from '@/views/CGVData.vue';
import CGVProposals from '@/views/CGVProposals.vue';
import ProposalDetails from '@/views/ProposalDetails.vue';
import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('cgv-consult'),
    component: CGVConsult,
  },
  {
    ...screen('cgv-pre-consult-form'),
    component: CGVPreConsultForm,
  },
  {
    ...screen('cgv-formalization'),
    component: CGVData,
  },
  {
    ...screen('cgv-proposals'),
    component: CGVProposals,
  },
  {
    ...screen('cgv-proposal-details'),
    component: ProposalDetails,
  },
  {
    ...screen('cgv-update-proposal'),
    component: () => import('@/views/cgv/UpdateProposal.vue'),
  },
];
